










































































import {Vue, Component, Prop, Emit} from 'nuxt-property-decorator'
import { FileUpload, HtmlEditor } from '@frontend/components'
import Autocomplete from '@/components/Autocomplete.vue'
import Sortable from '@/directives/sortable'
import QuickSelector from '@/components/QuickSelector.vue'

@Component({
  components: {
    Autocomplete,
    HtmlEditor,
    QuickSelector,
    FileUpload,
  },
  directives: {
    Sortable,
  },
})
export default class TileFormComponent extends Vue {
  @Prop({default: 1, type: Number}) currentTileNumber
  @Prop({default: () => {}, type: Object}) currentTile

  errors = null
  highlightFields = false

  get file() {
    return this.currentTile.file
  }

  get cover() {
    return this.currentTile.cover
  }

  get title() {
    return this.currentTile.title
  }

  get body() {
    return this.currentTile.body
  }

  set title(x) {
    this.onTitleUpdate(x)
  }

  set body(x) {
    this.onBodyUpdate(x)
  }

  @Emit('update')
  onTitleUpdate(title) {
    return {
      title
    }
  }

  @Emit('update')
  onFileUpdate(file) {
    return {
      file: file[0] ? file[0].url : '',
    }
  }

  @Emit('update')
  onCoverUpdate(file) {
    return {
      cover: file[0] ? file[0].url : '',
    }
  }

  @Emit('update')
  onBodyUpdate(body) {
    return {
      body,
    }
  }

  get imageUploadUrl() {
    return process.env.VUE_APP_API_ENDPOINT + 'upload/image'
  }

  get fileUploadUrl () {
    return process.env.VUE_APP_API_ENDPOINT + 'upload/file'
  }

  get token () {
    return `Bearer ${this.$login.getToken()}`
  }

  get headers () {
    return {
      Authorization: this.token,
    }
  }
}
